import { Asset, AssetKind } from "@hydrologiq/gql-experience/graphql"
import { GetAssetMonitoringDocument, AssetMonitoring } from "@hydrologiq/gql/graphql"
import InstallationMonitoringView from "@hydrologiq/shared/installation/InstallationMonitoringView"
import Informative from "@hydrologiq/shared/Informative"
import { useQuery } from "@apollo/client"
import { Skeleton } from "@chakra-ui/react/skeleton"
import batteryGraphs from "./graphs/Battery.json"
import { Figure, Graph } from "@hydrologiq/schemas/1.0.0/installationPage"
import generatorGraphs from "./graphs/Generator.json"
import generatorFigures from "./figures/Generator.json"
import MonitoringFigure from "./figures/Monitoring.json"
import { nowDateTime } from "@hydrologiq/common/helpers/date"
import { getAssignmentEndDate, getAssignmentStartDate, getMonitoredAssignments } from "@hydrologiq/shared/utils/assignmentDates"

const getAssetGraphs = (asset: Asset): [Figure[] | undefined, Graph[] | undefined] => {
  let figures: Figure[] | undefined = undefined
  let graphs: Graph[] | undefined = undefined
  switch (asset.kind) {
    case AssetKind.Battery:
      figures = []
      graphs = batteryGraphs as Graph[]
      break
    case AssetKind.Generator:
      figures = generatorFigures as Figure[]
      graphs = generatorGraphs as Graph[]
      break
  }
  if (figures) figures = [MonitoringFigure as Figure, ...figures]
  return [figures, graphs]
}

function AssetGraphs(props: { installation?: string; asset: Asset; onRefresh?: () => void }) {
  const { asset, onRefresh } = props

  const { data: dataMonitoring, loading: loadingMonitoring } = useQuery(GetAssetMonitoringDocument, {
    variables: {
      id: asset.id,
    },
  })

  const [figures, graphs] = getAssetGraphs(asset)

  const assignments = getMonitoredAssignments(asset.assignments?.all ?? [], asset.assignments?.monitored)
  if (assignments && assignments.length > 0) {
    // Derive effective date range from monitored assignments (falls back to all)
    const startDate = getAssignmentStartDate(assignments) ?? nowDateTime().toUtcIsoString()
    const endDate = getAssignmentEndDate(assignments)

    return (
      <InstallationMonitoringView
        onRefresh={onRefresh}
        installation={undefined}
        installationStartDate={startDate}
        installationEndDate={endDate}
        asset={asset.id}
        figures={dataMonitoring?.assetMonitoring?.figures ?? figures}
        graphs={dataMonitoring?.assetMonitoring?.graphs ?? graphs}
        assetContext={asset}
        assetMonitoring={dataMonitoring?.assetMonitoring as AssetMonitoring | undefined}
      />
    )
  }
  if (loadingMonitoring) return <Skeleton height="100%" width="100%" />
  return <Informative heading="No assignments" />
}
export default AssetGraphs
